import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import { getBooleanStatusBadgeColors } from '../utils/formatters';
const createdAtFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});
const formatRole = (role) => {
    if (!role)
        return 'N/A';
    return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
};
export const createClinicUserColumns = () => [
    {
        key: 'clinic',
        header: 'Clinic',
        sortable: true,
        render: (item) => item.clinic || 'N/A',
    },
    {
        key: 'user_name',
        header: 'User Name',
        sortable: true,
        render: (item) => item.user_name || 'N/A',
    },
    {
        key: 'user_email',
        header: 'Email',
        sortable: true,
        render: (item) => item.user_email || 'N/A',
    },
    {
        key: 'role',
        header: 'Role',
        sortable: true,
        render: (item) => formatRole(item.role),
    },
    {
        key: 'is_active',
        header: 'Is Active',
        sortable: true,
        render: (item) => {
            const label = item.is_active ? 'Active' : 'Inactive';
            const { background, text } = getBooleanStatusBadgeColors(!!item.is_active);
            return (_jsx(StatusBadge, { label: label, bgColor: background, color: text }));
        },
    },
    {
        key: 'is_default',
        header: 'Default',
        sortable: true,
        render: (item) => (item.is_default ? 'Yes' : 'No'),
    },
    {
        key: 'created_at',
        header: 'Created At',
        sortable: true,
        render: (item) => {
            if (item.created_at_display)
                return item.created_at_display;
            if (!item.created_at)
                return 'N/A';
            return createdAtFormatter.format(new Date(item.created_at));
        },
    },
];
